<section class="sub-footer" *ngIf="!excludedPage">
  <div class="container">
    <div class="sub-footer__wrapper">
      <div class="has-icon other-locations">
        <div class="icon locations"></div>
        <div class="info">
          <h5>Areas We Serve</h5>
          <p>
            Orland Park, Lockport, New Lenox, Mokena, Frankfort, Bolingbrook, Lisle, Lemont, Fairmont, Westmont
          </p>
        </div>
      </div>
      <div class="has-icon timings">
        <div class="icon time">

        </div>
        <div class="info">
          <h5>Office Hours</h5>
          <ul>
            <li *ngFor="let item of timings">
              <strong>{{item.day}}</strong>
              <span>{{item.timingFirst}}<br>{{item.lunch}}<br>{{item.timingSecond}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="book-cta">
        <button type="button" class="btn btn-primary" (click)="bookingViaFooterBtn()">Book Appointment</button>
      </div>
    </div>
  </div>
</section>
<footer>
  <div class="container">
    <div class="footer-menu">
      <ul>
        <li (click)="scrollToElement('appointments')"><a>Book Appointment</a></li>
        <li [routerLink]="['/special-offer']" routerLinkActive="active"><a>Special Offer</a></li>
        <li [routerLink]="['/about']" routerLinkActive="active"><a>About Practice</a></li>
        <li [routerLink]="['/services']" routerLinkActive="active"><a>Services</a></li>
        <li [routerLink]="['/privacy-policy']" routerLinkActive="active"><a>Privacy Policy</a></li>
        <!-- <li (click)="scrollToElement('testimonials')"><a>Testimonials</a></li> -->
      </ul>
    </div>
    <div class="address-ph">
      <div class="phone">
        <span class="title">Phone (appointments): </span>
        <span class="content">
          <a href="tel:+17087377136">708-737-7136</a>
        </span>
      </div>
      <div class="address">
        <span class="title">Address: </span>
        <article>15750 S Bell Road Suite 2D, Homer Glen, Illinois 60491</article>
      </div>
    </div>
    <div class="power">
      <span>
        Powered by <a href="https://patientmd.com"> <span class="blu">Patient</span>MD</a>
      </span>
    </div>
  </div>
  <div class="copyright">
    <span>
      Copyright &copy; 2026 | all rights reserved
    </span>
  </div>
</footer>